import { connect } from "react-redux";
import colores from "../../shared/constants/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useMemo } from "react";

interface AlertaFamiliaProps {
  cantidad: number;
  largo: number;
  ancho: number;
  cantMin: number;
  largoMin: number;
  largoMax: number;
  espesorSugerido?: number;
  espesor?: number;
  largoSugerido?: number;
  largoproducto?: number;
  open: boolean;
  handleConfirm: () => void;
  handleClose: () => void;
}

const AlertaFamilia = (props: AlertaFamiliaProps) => {
  const { alertas, esCritico } = useMemo(() => {
    const mensajes: string[] = [];
    let criticoLargoMin = false;
    let criticoLargoMax = false;
    let criticoCant = false;
    let criticoEspesor = false;
    let criticoLargo = false;

    if (props.largo > 0 && props.largo < props.largoMin) {
      mensajes.push(
        `Largo mínimo debe ser mayor a ${props.largoMin}, por favor verificar.`,
      );
      criticoLargoMin = true;
    }
    if (props.largo > props.largoMax) {
      mensajes.push(
        `Largo máximo debe ser menor a ${props.largoMax}, por favor verificar.`,
      );
      criticoLargoMax = true;
    }
    if (props.cantidad < props.cantMin) {
      mensajes.push(
        `La cantidad de compra mínima de este producto es de ${props.cantMin}, por favor verificar.`,
      );
      criticoCant = false;
    }
    if (
      props.espesorSugerido &&
      props.espesor &&
      props.espesor !== props.espesorSugerido
    ) {
      mensajes.push(
        `El espesor seleccionado no es el más habitual, el espesor sugerido es ${props.espesorSugerido}, por favor verificar.`,
      );
      criticoEspesor = false;
    }
    if (
      props.largoSugerido &&
      props.largoproducto &&
      props.largoproducto !== props.largoSugerido
    ) {
      mensajes.push(
        `El largo seleccionado no es el más habitual, el largo sugerido es ${props.largoSugerido}, por favor verificar.`,
      );
      criticoLargo = false;
    }

    return {
      alertas: mensajes,
      esCritico:
        criticoLargoMin || criticoLargoMax || criticoCant || criticoEspesor || criticoLargo,
    };
  }, [
    props.largo,
    props.largoMin,
    props.largoMax,
    props.cantidad,
    props.cantMin,
    props.espesorSugerido,
    props.espesor,
    props.largoSugerido,
    props.largoproducto,
  ]);

  useEffect(() => {
    if (props.open) {
      console.log("Alertas detectadas:", alertas);
    }
  }, [props.open, alertas]);

  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {
          "Existen restricciones en las dimensiones de la compra de este producto."
        }
      </DialogTitle>
      <DialogContent>
        {alertas.length > 0 ? (
          <>
            {alertas.map((alerta, index) => (
              <DialogContentText
                key={index}
                id={`alert-dialog-description-${index}`}
                style={{ marginBottom: "0.5rem" }}
              >
                • {alerta}
              </DialogContentText>
            ))}
          </>
        ) : (
          <DialogContentText id="alert-dialog-description">
            Por favor, revise los valores ingresados.
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <button
          className="btn btn-danger"
          type="button"
          onClick={props.handleClose}
          style={{
            backgroundColor: colores.grisOscuro,
            borderColor: colores.grisOscuro,
            padding: "0.625rem",
            marginTop: "1.25rem",
            inlineSize: "10rem",
          }}
        >
          Volver
        </button>
        {!esCritico && (
          <button
            className="btn btn-danger"
            type="button"
            onClick={props.handleConfirm}
            style={{
              backgroundColor: colores.rojo,
              padding: "0.625rem",
              marginTop: "1.25rem",
              inlineSize: "10rem",
              marginLeft: "1rem",
            }}
          >
            Continuar
          </button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default connect()(AlertaFamilia);
